//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import angular from 'angular';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { Like2BuyV2ModerationItemFilter } from '@apis/like2buy-v2/like2BuyV2ModerationModel';
import { RequiredPermissionsSecondaryButton } from '@components/atoms/required-permissions-button/RequiredPermissionsButton';
import makeAngularReactController from '@react-bridge/angular-react-widget';
import { getBulkActionsActions } from '@react-bridge/wrappers/ng-service-provider';
import { TikTokLike2BuyTrackingIds } from '@tiktok/components/like2buy/TikTokLike2BuyTrackingIds';
import {
  getTikTokLike2BuyCurrentItemFilter,
  getTikTokLike2BuyFlags,
  getTikTokLike2BuySelectedItems,
} from '@tiktok/redux/like2buy/selectors/getTikTokLike2Buy';
import { TIKTOK_L2B_MODERATE_TASK } from '@tiktok/redux/like2buy/tiktokLike2BuyModel';
import { archiveItems } from '@tiktok/redux/like2buy/tiktokLike2BuySlice';

export const TikTokLike2BuyBulkActions = () => {
  const dispatch = useDispatch();

  const selectedItems = useSelector(getTikTokLike2BuySelectedItems);
  const { isArchivingItems } = useSelector(getTikTokLike2BuyFlags);
  const currentItemFilter = useSelector(getTikTokLike2BuyCurrentItemFilter);

  const onArchive = () => {
    void dispatch(archiveItems(selectedItems));
    dispatch(getBulkActionsActions().clearSelectedItems());
  };

  return (
    <>
      <StyledButton
        iconName='archive'
        isDisabled={
          isArchivingItems ||
          currentItemFilter === Like2BuyV2ModerationItemFilter.Archived
        }
        onClick={onArchive}
        permissionName={TIKTOK_L2B_MODERATE_TASK}
        trackingId={TikTokLike2BuyTrackingIds.ARCHIVE_BULK_ACTION_BUTTON}
      >
        Archive
      </StyledButton>
    </>
  );
};

const StyledButton = styled(RequiredPermissionsSecondaryButton).attrs({
  // TODO we should update bulk actions buttons with standard button styles
  buttonStyles: {
    fixed: {
      fontWeight: 'bold',
      borderShape: 'pill',
      borderThickness: 'thick',
    },
    standard: {
      color: theme.colors.white,
      backgroundColor: theme.colors.aliases.primary,
      borderColor: theme.colors.white,
    },
    hover: {
      color: theme.colors.aliases.primary,
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
    },
    active: {
      color: theme.colors.aliases.primary,
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
    },
    disabled: {
      color: theme.colors.gray4,
      backgroundColor: theme.colors.gray0,
      borderColor: theme.colors.gray0,
    },
  },
})(
  ({ theme }) => `
  margin-right: ${theme.spacings[2]};
  height: 100%;
`,
);

angular.module('curalate').component('tiktokLike2buyBulkActions', {
  controller: makeAngularReactController(<TikTokLike2BuyBulkActions />),
});
